import type { ImageSet } from "@pax/api-contract/common";

/** An image's sources as a `srcset`, so the browser loads the smallest one that covers the space it's drawn in. */
export function srcSet(image: ImageSet): string {
  return image.sources.map(source => `${source.url} ${source.width}w`).join(", ");
}

/** An image's largest source, for where only one URL fits, such as an `<img>` that fills its box. */
export function largestSource(image: ImageSet): string {
  const largest = image.sources.at(-1);
  if (!largest) throw new Error("An image set has no sources.");
  return largest.url;
}
